module.exports = __webpack_public_path__ + "img/9791189015091.f85632ac.jpg";